module.exports = __webpack_public_path__ + "static/media/actmt-heart-icon-transparent.83e3f47e.svg";